import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Autoplay, FreeMode } from 'swiper/modules';
import VideoItem from './VideoItem';
import { useSelector } from 'react-redux';

const VideosContent = () => {

    const videoBlobs = useSelector((state) => state.videos.blobsAvatars);


    return (
        <Swiper
            spaceBetween={13}
            slidesPerView={2.2}
            allowTouchMove={false}
            speed={2000}
            loop={true}
            autoplay={{
                delay: 0,
                disableOnInteraction: false,
            }}
            freeMode={true}
            modules={[Autoplay, FreeMode]

            }
        >
            <SwiperSlide>
                <VideoItem text={'AI Zoom'} video={videoBlobs['avatar-video-03']} img={'88e529a0-b6cf-11ef-9b31-a3568a030dcd.webp'} />
            </SwiperSlide>
            <SwiperSlide>
                <VideoItem text={'Product demo'} video={videoBlobs['avatar-video-02']} img={'85d82d30-b6ce-11ef-aece-6baa89046ed6.webp'} />
            </SwiperSlide>
            <SwiperSlide>
                <VideoItem text={'Review'} video={videoBlobs['avatar-video-01']} img={'1d18e890-b6cc-11ef-81c2-0be77ef0b4c9.webp'} />
            </SwiperSlide>
            <SwiperSlide>
                <VideoItem text={'AI Zoom'} video={videoBlobs['avatar-video-06']} img={'f6b5f4a0-b6cf-11ef-9b31-a3568a030dcd.webp'} />
            </SwiperSlide>
            <SwiperSlide>
                <VideoItem text={'Product demo'} video={videoBlobs['avatar-video-04']} img={'0440bd70-b6cc-11ef-81c2-0be77ef0b4c9.webp'} />
            </SwiperSlide>
            <SwiperSlide>
                <VideoItem text={'Product demo'} video={videoBlobs['avatar-video-05']} img={'eaf0a330-b6cb-11ef-81c2-0be77ef0b4c9.webp'} />
            </SwiperSlide>
        </Swiper>
    );
}

export default VideosContent;